import React from 'react'
import mainData from '../../FetchDataLinks'
import UseFetch from '../../UseFetch'

function PreviousPost({ id }) {
    const { blogs, loading } = UseFetch(`${mainData.prevPost}${id}/`)
    return (
        <>
            {!loading && <a className="prev-post pull-left" href={blogs.slug}><span className="fa fa-arrow-left" aria-hidden="true" />Previous Post</a>}
        </>
    )
}

export default PreviousPost
